
<template>
    <v-data-table object :headers="tableHeaders" :items="tableItems" dense hide-default-footer :items-per-page="1000" style="height: 150px; overflow-y: auto">
        <template v-slot:item="props">
            <tr>
                <td style="height: 25px" class="text-left">{{props.item.name}}</td>
                <td style="height: 25px"  class="text-right"><v-btn small :color="props.item.Color"  @click="colorPicker(props.item)"></v-btn></td>
                <td><v-icon color="red" small @click="deleteItem(props.item)">clear</v-icon></td>    
            </tr>   
        </template>                    
    </v-data-table>
</template>

<script>
/* eslint-disable */

export default {
    data(){
        return{
            initStatus: this.$store.initStatus,
            tableHeaders: [
                    { text: 'Name', align: 'left', value: 'name'},
                    { text: 'Farbe', align: 'right', sortable: false, value: 'Color'},
                    { value: 'Actions', width: '30px' }
                ],
        }
    },
    computed: {
        tableItems() { return this.$store.state.StatikSystem.Lastfallliste},
    },
    methods: {
        colorPicker(lastfall){
            this.$store.state.cLastfall = lastfall
            this.$store.commit('setvColorPicker', true)
        }
    }
}
</script>

<style scoped>
    select {
        padding-left: 5px; 
        padding-right: 5px;
        cursor: pointer;
        border-style: solid;
    }
    input {
        cursor: pointer;
        border-style: solid;
        border-width: thin;
    }
    .v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table--dense > .v-data-table__wrapper > table > thead > tr > td, .v-data-table--dense > .v-data-table__wrapper > table > tfoot > tr > td {
    height: 25px;
    }   
</style>